// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label-radioButtons-wrapper {
  display: flex;
  -webkit-display: flex;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 15px;
}
.label-radioButtons-wrapper > .group-label {
  color: #222222;
  font-size: 14px;
  line-height: 1.5;
  padding-right: 20px;
}
.label-radioButtons-wrapper .radio-buttons-wrapper {
  display: flex;
  align-items: center;
  margin-left: 5px;
}
.label-radioButtons-wrapper .radio-button {
  position: relative;
  margin-right: 10px;
}
.label-radioButtons-wrapper .radio-button:last-child {
  margin-right: 0;
}
.label-radioButtons-wrapper .radio-button .radio {
  position: absolute;
  height: 0;
  width: 0;
  margin: 0;
  opacity: 0;
  top: 0;
  left: 0;
}
.label-radioButtons-wrapper .radio-label {
  font-size: 12px;
  color: #505050;
  display: inline-block;
  background: #f4f7fa;
  padding: 5px 12px;
  border-radius: 20px;
  cursor: pointer;
  margin-right: 10px;
}
.label-radioButtons-wrapper .radio:checked ~ .radio-label {
  background: #e0a633;
  color: #fff;
}
.no-margin {
  margin: 0;
}

.label-radioButtons-wrapper .radio:disabled ~ .radio-label {
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/labelRadioButtons/LabelRadioButtons.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,SAAS;EACT,UAAU;EACV,MAAM;EACN,OAAO;AACT;AACA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".label-radioButtons-wrapper {\n  display: flex;\n  -webkit-display: flex;\n  align-items: flex-start;\n  width: 100%;\n  margin-bottom: 15px;\n}\n.label-radioButtons-wrapper > .group-label {\n  color: #222222;\n  font-size: 14px;\n  line-height: 1.5;\n  padding-right: 20px;\n}\n.label-radioButtons-wrapper .radio-buttons-wrapper {\n  display: flex;\n  align-items: center;\n  margin-left: 5px;\n}\n.label-radioButtons-wrapper .radio-button {\n  position: relative;\n  margin-right: 10px;\n}\n.label-radioButtons-wrapper .radio-button:last-child {\n  margin-right: 0;\n}\n.label-radioButtons-wrapper .radio-button .radio {\n  position: absolute;\n  height: 0;\n  width: 0;\n  margin: 0;\n  opacity: 0;\n  top: 0;\n  left: 0;\n}\n.label-radioButtons-wrapper .radio-label {\n  font-size: 12px;\n  color: #505050;\n  display: inline-block;\n  background: #f4f7fa;\n  padding: 5px 12px;\n  border-radius: 20px;\n  cursor: pointer;\n  margin-right: 10px;\n}\n.label-radioButtons-wrapper .radio:checked ~ .radio-label {\n  background: #e0a633;\n  color: #fff;\n}\n.no-margin {\n  margin: 0;\n}\n\n.label-radioButtons-wrapper .radio:disabled ~ .radio-label {\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
